<template>
  <div class="case-prize">
    <div>
      <el-button icon="el-icon-back" @click="$router.back()">返回</el-button>
      <el-button size="small" type="primary" @click="handleAdd">添加Roll房活动奖品</el-button>
    </div>
    <div>
      <el-table :data="dataList" v-loading="loading" :row-class-name="tableRowClassName">>
        <el-table-column prop="id" label="奖品ID" width="100px">
          <template slot-scope="{ row }">{{ row.prize.id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="奖品名称">
          <template slot-scope="{ row }">{{ row.prize.name }}</template>
        </el-table-column>
        <el-table-column label="图片">
          <template slot-scope="{ row }">
            <img class="table-image" :src="row.prize.image" alt />
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格">
          <template slot-scope="{ row }">{{ row.prize.price }}</template>
        </el-table-column>
        <el-table-column prop="category_id" label="所属分类">
          <template slot-scope="{ row }">{{
              getCategoryName(row.prize.category_id)
          }}</template>
        </el-table-column>
        <el-table-column prop="status" label="等级">
          <template slot-scope="{ row }">
            <span :style="`color: ${getRankColor(row.prize.rank)};`">{{
                getRank(row.prize.rank)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="权重"></el-table-column>
        <!--				<el-table-column prop="number" label="数量">-->
        <!--					<template slot-scope="{ row }">-->
        <!--            <span-->
        <!--							:style="-->
        <!--                `color: ${-->
        <!--                  row.prize.number < 20-->
        <!--                    ? '#c00'-->
        <!--                    : '#333'-->
        <!--                };`-->
        <!--              "-->
        <!--						>{{ row.prize.number }}</span-->
        <!--						>-->
        <!--					</template>-->
        <!--				</el-table-column>-->
        <el-table-column label="操作" width="300px">
          <template slot-scope="{ row }">
            <!--						<el-button type="primary" plain @click="handleEditPrize(row)"-->
            <!--						>饰品</el-button-->
            <!--						>-->
            <el-button type="primary" plain @click="handleEdit(row)">编辑</el-button>
            <!--						<el-button-->
            <!--							type="primary"-->
            <!--							@click="-->
            <!--                handleChangeNumber(-->
            <!--                  row.prize.id,-->
            <!--                  row.prize.number-->
            <!--                )-->
            <!--              "-->
            <!--						>修改数量</el-button-->
            <!--						>-->
            <el-button type="danger" @click="handleDelete(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="visible" :title="isEdit ? '编辑奖品' : '添加奖品'" width="400px" :close-on-click-modal="false">
      <el-form :model="formData" label-width="100px" :rules="rules" ref="form">
        <el-form-item prop="prize_id" label="奖品">
          <div v-if="selectedPrize" class="prize-item">
            <img :src="selectedPrize.image" alt />
            <p>
              <span>{{ selectedPrize.name }}</span>
            </p>
            <p>
              <span>{{ selectedPrize.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(selectedPrize.rank)};`">{{
                  getRank(selectedPrize.rank)
              }}</span>
              <span class="price">${{ selectedPrize.price }}</span>
            </p>
          </div>
          <div v-else class="add-prize" @click="visiblePrize = true">
            <i class="el-icon-plus"></i>
            <p>选择奖品</p>
          </div>
        </el-form-item>
        <el-form-item prop="state" label="状态">
          <el-radio v-model="formData.state" :label="1">开</el-radio>
          <el-radio v-model="formData.state" :label="0">关</el-radio>
        </el-form-item>
        <el-form-item prop="weight" label="权重">
          <el-input v-model="formData.weight" placeholder="排序"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="visiblePrize" title="奖品列表" :close-on-click-modal="false" width="930px">
      <el-row style="margin-bottom: 20px;">
        <el-input style="width: 200px; margin-right: 20px;" placeholder="奖品名称搜索" v-model="prizeName"></el-input>
        <el-button type="primary" @click="getPrize">搜索</el-button>
      </el-row>
      <div class="prize-list-wrap" v-loading="loadingPrize">
        <ul class="prize-list">
          <li class="prize-item" v-for="item in prizeList" :key="item.id">
            <i class="el-icon-plus" title="添加" @click="handleAddPrize(item)"></i>
            <img :src="item.image" alt />
            <p>
              <span>{{ item.name }}</span>
            </p>
            <p>
              <span>{{ item.second_name }}</span>
            </p>
            <p>
              <span :style="`color: ${getRankColor(item.rank)};`">{{
                  getRank(item.rank)
              }}</span>
              <span class="price">${{ item.price }}</span>
            </p>
            <p style="text-align: center;">
              数量：{{ item.number - item.sold_number }}
            </p>
          </li>
        </ul>
      </div>
      <el-pagination background :page-size="prizeListMeta.per_page || 15" :total="prizeListMeta.total || 0"
        :current-page="prizePage" @current-change="handlePrizePageChange"
        v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"></el-pagination>
    </el-dialog>
    <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0" :current-page="page"
      @current-change="handlePageChange" v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    <!--		<el-dialog-->
    <!--			:visible.sync="visibleEditPrize"-->
    <!--			title="编辑奖品"-->
    <!--			width="400px"-->
    <!--			destroy-on-close-->
    <!--			:close-on-click-modal="false"-->
    <!--		>-->
    <!--			<el-form :model="formPrizeData" label-width="100px" :rules="rules" ref="form">-->
    <!--				<el-form-item prop="name" label="奖品名称">-->
    <!--					<el-input v-model="formPrizeData.name"></el-input>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="second_name" label="第二名称">-->
    <!--					<el-input v-model="formPrizeData.second_name"></el-input>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="image" label="图片">-->
    <!--					<el-upload-->
    <!--						class="avatar-uploader"-->
    <!--						:action="action"-->
    <!--						:show-file-list="false"-->
    <!--						:on-success="handleUploadSuccess"-->
    <!--						:before-upload="beforeImageUpload"-->
    <!--						:headers="headers"-->
    <!--						accept="image/*"-->
    <!--						name="file"-->
    <!--					>-->
    <!--						<img class="avatar" v-if="formPrizeData.image" :src="formPrizeData.image" />-->
    <!--						<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
    <!--					</el-upload>-->
    <!--					<p>推荐尺寸256 * 192（4:3）</p>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="price" label="价格">-->
    <!--					<el-input v-model="formPrizeData.price"></el-input>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="category_id" label="奖品分类">-->
    <!--					<el-select-->
    <!--						v-model="formPrizeData.category_id"-->
    <!--						placeholder="请选择奖品分类"-->
    <!--					>-->
    <!--						<el-option-->
    <!--							v-for="item in categories"-->
    <!--							:key="item.id"-->
    <!--							:label="item.name"-->
    <!--							:value="item.id"-->
    <!--						></el-option>-->
    <!--					</el-select>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="rank" label="等级">-->
    <!--					<el-select v-model="formPrizeData.rank">-->
    <!--						<el-option-->
    <!--							v-for="item in ranks"-->
    <!--							:key="item.level"-->
    <!--							:value="item.level"-->
    <!--							:label="item.text"-->
    <!--						>-->
    <!--							<span :style="`color: ${item.color};`">{{ item.text }}</span>-->
    <!--						</el-option>-->
    <!--					</el-select>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="wear_degree" label="磨损度">-->
    <!--					<el-select v-model="formPrizeData.wear_degree">-->
    <!--						<el-option-->
    <!--							v-for="item in quality"-->
    <!--							:key="item.degree"-->
    <!--							:value="item.degree"-->
    <!--							:label="item.text"-->
    <!--						>-->
    <!--							<span>{{ item.text }}</span>-->
    <!--						</el-option>-->
    <!--					</el-select>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="delivery_type" label="发货方式">-->
    <!--					<el-select v-model="formPrizeData.delivery_type">-->
    <!--						<el-option-->
    <!--							v-for="item in deliveryType"-->
    <!--							:key="item.value"-->
    <!--							:value="item.value"-->
    <!--							:label="item.text"-->
    <!--						>-->
    <!--							<span>{{ item.text }}</span>-->
    <!--						</el-option>-->
    <!--					</el-select>-->
    <!--				</el-form-item>-->
    <!--				<el-form-item prop="number" label="数量" v-if="!isEdit">-->
    <!--					<el-input-->
    <!--						v-model="formPrizeData.number"-->
    <!--						placeholder="奖品初始数量"-->
    <!--					></el-input>-->
    <!--				</el-form-item>-->
    <!--			</el-form>-->
    <!--			<span slot="footer" class="dialog-footer">-->
    <!--        <el-button size="small" @click="visibleEditPrize = false">取 消</el-button>-->
    <!--        <el-button-->
    <!--					size="small"-->
    <!--					type="primary"-->
    <!--					@click="submitEdit"-->
    <!--					:loading="buttonLoadingEditPrize"-->
    <!--				>确 定</el-button-->
    <!--				>-->
    <!--      </span>-->
    <!--		</el-dialog>-->
  </div>
</template>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
<script>
import { mapState, mapActions } from 'vuex'
import { server, getData, delApiData, patchApiData, getApiData, postApiData } from '../../http'
import { getCookie } from '../../utils/cookie'
import quality from '@/utils/quality'
import deliveryType from '@/utils/deliveryType'
import ranks from '@/utils/ranks'

export default {
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    this.ranks = ranks
    return {
      quality,
      deliveryType,
      formData: {
        prize_id: undefined,
        state: 1,
        weight: undefined
      },
      formPrizeData: {
        prize_id: '',
        second_name: '',
        image: '',
        price: '',
        rank: 1,
        category_id: 1,
        wear_degree: 0,
        number: '',
        delivery_type: 1
      },
      rules: {
        prize_id: [{ required: true, message: '请选择要添加到奖品' }],
        weight: [{ required: true, message: '请输入排序' }],
        state: [{ required: true, message: '请输入状态' }]
      },
      page: 1,
      prizePage: 1,
      prizeName: '',
      editInfo: undefined,
      loading: false,
      visible: false,
      buttonLoading: false,
      isEdit: false,
      dataList: undefined,
      dataMeta: {},
      visiblePrize: false,
      loadingPrize: false,
      prizeList: undefined,
      prizeListMeta: {},
      selectedPrize: undefined,
      isEditPrize: false,
      editPrizeInfo: undefined,
      visibleEditPrize: false,
      buttonLoadingEditPrize: false,
      check_prize_id: 0
    }
  },
  computed: {
    ...mapState({
      categories: state => state.data.categories
    }),
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${server}file`
    },
    cid() {
      return this.$route.query.cid
    }
  },
  // watch: {
  // 	visible(val) {
  // 		if (this.editInfo) {
  // 			const { display_probability, true_probability, weight } = this.editInfo
  // 			this.formData = {
  // 				...this.formData,
  // 				true_probability,
  // 				display_probability,
  // 				weight
  // 			}
  // 		} else {
  // 			if (this.$refs['form']) {
  // 				this.$refs['form'].resetFields()
  // 				this.formData = {
  // 					prize_id: undefined,
  // 					display_probability: '',
  // 					true_probability: '',
  // 					weight: undefined
  // 				}
  // 				this.selectedPrize = undefined
  // 			}
  // 		}
  // 	}
  // },
  methods: {
    ...mapActions(['getCategories']),
    tableRowClassName({ row, rowIndex }) {
      if (row.id === this.check_prize_id) {
        return 'warning-row'
      }
      return ''
    },
    getRank(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.text
        }
      }
    },
    getRankColor(rank) {
      for (let item of this.ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getCategoryName(id) {
      if (this.categories) {
        for (let item of this.categories) {
          if (item.id === id) {
            return item.name
          }
        }
      } else {
        return ''
      }
    },
    getData() {
      this.loading = true
      getApiData(`rollActivityPrize/${this.id}`, { page: this.page })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = res.meta
          this.check_prize_id = res.prize_id
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPrize() {
      this.loadingPrize = true
      getData(`prize`, { page: this.prizePage, name: this.prizeName })
        .then(res => {
          this.prizeList = res.data
          this.prizeListMeta = res.meta
        })
        .finally(() => {
          this.loadingPrize = false
        })
    },
    beforeImageUpload(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
        return false
      }
    },
    handleUploadSuccess(res) {
      if (res.path) {
        this.formPrizeData.image = res.path
      } else {
        this.$message.error('上传失败')
      }
      this.$refs['form'].validateField('image')
    },
    handleAdd() {
      this.isEdit = false
      this.editInfo = undefined
      this.visible = true
      this.selectedPrize = undefined
      this.formData.state = 1
      this.formData.weight = undefined
    },
    handleEdit(row) {
      this.isEdit = true
      this.editInfo = row
      this.visible = true
      this.selectedPrize = row.prize
      this.formData = row
    },
    handleEditPrize(row) {
      this.isEditPrize = true
      this.editPrizeInfo = row.prize
      this.formPrizeData = row.prize
      this.visibleEditPrize = true
    },
    handleAddPrize(row) {
      this.formData.prize_id = row.id
      this.selectedPrize = row
      this.visiblePrize = false
    },
    handleRemovePrize() {
      this.formData.prize_id = undefined
      this.selectedPrize = undefined
    },
    handlePageChange(page) {
      this.page = page
      this.getData()
    },
    handlePrizePageChange(page) {
      this.prizePage = page
      this.getPrize()
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`rollActivityPrize/${id}`).then(res => {
          if (res.err === 0) {
            this.$message.success(res.msg)
          } else {
            this.$message.warning(res.msg)
          }
          this.getData()
        })
      })
    },
    // handleChangeNumber(id, number) {
    // 	this.$prompt('', '修改奖品数量', {
    // 		confirmButtonText: '确定',
    // 		cancelButtonText: '取消',
    // 		//inputPlaceholder: '正值增加，负值减少',
    // 		customClass: 'change-prize-number',
    // 		closeOnClickModal: false,
    // 		inputPattern: /^(\-?)\d+(\.\d+)?$/,
    // 		inputErrorMessage: '请输入数字'
    // 	}).then(({ value }) => {
    // 		if (parseInt(number) + parseInt(value) < 0) {
    // 			this.$message.error('奖品数量不能为负')
    // 			return
    // 		}
    // 		patchData(`prize/${id}`, {
    // 			number: value
    // 		}).then(res => {
    // 			this.$message.success('修改成功')
    // 			this.getData()
    // 		})
    // 	})
    // },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.buttonLoading = true
          if (!this.editInfo) {
            postApiData(`rollActivityPrize`, {
              ...this.formData,
              roll_id: this.id
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                if (res.err === 0) {
                  this.$message.success(res.msg)
                } else {
                  this.$message.warning(res.msg)
                }
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          } else {
            patchApiData(`rollActivityPrize/${this.editInfo.id}`, {
              prize_id: this.formData.prize_id,
              state: this.formData.state,
              weight: this.formData.weight,
              roll_id: this.id
            })
              .then(res => {
                this.buttonLoading = false
                this.visible = false
                if (res.err === 0) {
                  this.$message.success(res.msg)
                } else {
                  this.$message.warning(res.msg)
                }
                this.getData()
              })
              .finally(() => {
                this.buttonLoading = false
              })
          }
        }
      })
    },
    // submitEdit() {
    // 	patchData(`prize/${this.editPrizeInfo.id}`, {
    // 		...this.formPrizeData
    // 	})
    // 		.then(res => {
    // 			this.buttonLoadingEditPrize = false
    // 			this.visibleEditPrize = false
    // 			this.$message.success('编辑成功')
    // 			this.getData()
    // 		})
    // 		.finally(() => {
    // 			this.buttonLoadingEditPrize = false
    // 		})
    // }
  },
  created() {
    this.getData()
    this.getPrize()
    !this.categories && this.getCategories()
  }
}
</script>
